module.exports = __webpack_public_path__ + "img/imgCut.fc4005dc.jpg";